import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { LoginPage } from "./pages/LoginPage";
import { SignupPage } from "./pages/SignupPage";
import { LandingPage } from "./pages/LandingPage";
import { DashboardPage } from "./pages/DashboardPage";
import { AdminPage } from "./pages/AdminPage";
import { PluginDetailPage } from "./pages/PluginDetailPage";
import { PackLandingPage } from "./pages/PackLandingPage";
import { SkillCreatorPage } from "./pages/SkillCreatorPage";
import { DocsPage } from "./pages/DocsPage";
import { MarketplaceDashboardPage } from "./pages/MarketplaceDashboardPage";
import { MarketplaceEditPage } from "./pages/MarketplaceEditPage";
import { PublicMarketplacePage } from "./pages/PublicMarketplacePage";
import { MarketplacesListPage } from "./pages/MarketplacesListPage";
import { PurchasesPage } from "./pages/PurchasesPage";
import { EarningsPage } from "./pages/EarningsPage";
import { PaymentSettingsPage } from "./pages/PaymentSettingsPage";
import { BeginnerMarketplacePage } from "./pages/BeginnerMarketplacePage";
import { ProtectedRoute } from "./components/auth/ProtectedRoute";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/explore" element={<LandingPage />} />
          <Route path="/categories" element={<LandingPage />} />
          <Route path="/docs" element={<DocsPage />} />
          <Route path="/packs/:packId" element={<PackLandingPage />} />
          <Route path="/create" element={<SkillCreatorPage />} />
          <Route path="/browse/marketplaces" element={<MarketplacesListPage />} />
          <Route path="/m/:slug" element={<PublicMarketplacePage />} />
          <Route path="/easy" element={<BeginnerMarketplacePage />} />

          {/* Protected routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/marketplaces"
            element={
              <ProtectedRoute>
                <MarketplaceDashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/marketplaces/:id/edit"
            element={
              <ProtectedRoute>
                <MarketplaceEditPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/purchases"
            element={
              <ProtectedRoute>
                <PurchasesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/earnings"
            element={
              <ProtectedRoute>
                <EarningsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/payments"
            element={
              <ProtectedRoute>
                <PaymentSettingsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminPage />
              </ProtectedRoute>
            }
          />
          {/* Plugin detail - public for published plugins, auth handled in component */}
          <Route path="/plugin/:slug" element={<PluginDetailPage />} />
          <Route path="/plugin/:slug/v/:version" element={<PluginDetailPage />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
